export default __webpack_public_path__ + "static/media/kitchen5-afterB-1920w.2dd4eb3b.png";